export default {
      id: "medical-illness-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#medical-illness",
      toString: function () {
        return this.url;
      }
    }